import { i18n_t as $t } from '@/utils/i18n';

export const eligibleVisitorsPreviewLimit = 250;

export function getIneligibleVisitorsReasons () {
    return Object.freeze([
        $t("common.They haven't used your app or had their metadata updated in the last 12 months."),
        $t('common.They match an entry on the exclude list.'),
    ]);
}

export function getIneligibleVisitorsTooltipMessage () {
    const reasons = `<ul class="reasons"> ${getIneligibleVisitorsReasons()
        .map((reason) => `<li>${reason}</li>`)
        .join('')} </ul>`;

    return $t(
        "common.Visitor eligibility is evaluated dynamically based on recent activity or metadata updates. Visitors won't appear as eligible if: {reasons} Manually uploaded visitors who haven't logged in will appear once they use your app or their metadata is updated.",
        {
            reasons,
        },
    );
}

export function getIneligibleVisitorsTooltipText () {
    const reasons = getIneligibleVisitorsReasons().join(' ');

    return $t(
        "common.Eligible visitors count will be updated as rules are updated. Visitors won't appear as eligible if: {reasons} Manually uploaded visitors who haven't logged in will appear once they use your app or their metadata is updated.",
        {
            reasons,
        },
    );
}
